interface Props {
  onClose: () => void;
  label: string;
  className?: string;
}

export function DialogClose({ onClose, label, className = "" }: Props) {
  return (
    <button type="button" onClick={onClose} aria-label={label} title="Close (Esc)" className={`dialog-close ${className}`}>
      <svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
        <path d="m3 3 10 10M13 3 3 13" />
      </svg>
    </button>
  );
}
